export const getActiveGroups = () => {
  const activeGroupStr = window?.OnetrustActiveGroups;
  if (activeGroupStr) {
    return activeGroupStr.split(',').filter(str => !!str);
  }
  return [];
};
export const getCategoryList = () => {
  // only categories with cookies associated are relevant
  const groups = window?.OneTrust?.GetDomainData().Groups || [];
  return groups
    .filter(group => !!group.Cookies.length)
    .map(group => group.CustomGroupId);
};

export const removeCookies = (categoryList, activeGroups) => {
  const categoriesToDelete = categoryList.filter(category => {
    return !activeGroups.includes(category);
  });
  const groupsToDelete = window?.OneTrust?.GetDomainData()?.Groups.filter(
    group => categoriesToDelete.includes(group.CustomGroupId),
  );
  groupsToDelete.forEach(group => {
    group.Cookies.forEach(cookie => {
      eraseCookie(cookie.Name, cookie.description);
    });
  });
};

const eraseCookie = (name, domain) => {
  // Delete cookies associated with uat domains
  const sanitizedDomain = domain.trim().replace(/\s+/g, '');
  const domainList = ['.uat.pcfinancial.ca', 'www.uat.pcfinancial.ca'];
  domainList.forEach(dmns => {
    document.cookie = `${name}=; Max-Age=-99999999; Path=/;Domain=${dmns}`;
  });
  // delete cookies specified by one trust
  document.cookie = `${name}=; Max-Age=-99999999; Path=/;Domain=${sanitizedDomain}`;
};
